import { Controller } from 'react-hook-form';
import { RadioCard } from '@paysera/ui';
const RadioCardField = ({ name, label, options, control, onAfterChange }) => (<Controller name={name} control={control} render={({ field: controllerField }) => (<div>
                <label className="block mb-2 label-m">{label}</label>
                <div className="flex flex-col gap-2">
                    {options.map((option) => (<RadioCard key={option.value} name={name} value={option.value} checked={String(controllerField.value) === option.value} onChange={() => {
                controllerField.onChange(option.value);
                onAfterChange();
            }}>
                            <span className="title-s">{option.label}</span>
                        </RadioCard>))}
                </div>
            </div>)}/>);
export default RadioCardField;
